'use strict';

exports.__esModule = true;
var isClassComponent = function isClassComponent(Component) {
  return Boolean(Component && Component.prototype && typeof Component.prototype.render === 'function');
};

exports.default = isClassComponent;


//////////////////
// WEBPACK FOOTER
// ./node_modules/recompose/isClassComponent.js
// module id = 367
// module chunks = 0